module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l content_right flex_container p10"
  }, [_c('div', {
    staticClass: "left-section"
  }, [_c('div', {
    staticClass: "title cl"
  }, [_c('span', {
    staticClass: "l"
  }, [_vm._v("资源组")]), _vm._v(" "), _c('el-button', {
    staticClass: "r",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addResourceGroup
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('ul', _vm._l((_vm.groupList), function(item) {
    return _c('li', {
      staticClass: "cl"
    }, [_c('span', {
      staticClass: "l name",
      class: {
        active: item.resourcegroupid === _vm.curGroup.resourcegroupid
      },
      on: {
        "click": function($event) {
          _vm.switchGroup(item)
        }
      }
    }, [_vm._v(_vm._s(item.resourcegroupname))]), _vm._v(" "), _c('span', {
      staticClass: "r edit",
      attrs: {
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          _vm.editGroup(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "r delete",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.deleteGroup(item.resourcegroupid)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "title cl"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("资源类型:")]), _vm._v(" "), _c('span', {
    staticClass: "l type-item",
    class: {
      active: _vm.resourceType == '0'
    },
    on: {
      "click": function($event) {
        _vm.switchResourceType(0)
      }
    }
  }, [_vm._v("服务资源")]), _vm._v(" "), _c('span', {
    staticClass: "l type-item",
    class: {
      active: _vm.resourceType == '1'
    },
    on: {
      "click": function($event) {
        _vm.switchResourceType(1)
      }
    }
  }, [_vm._v("客户端使用资源")]), _vm._v(" "), _c('span', {
    staticClass: "l type-item",
    class: {
      active: _vm.resourceType == '2'
    },
    on: {
      "click": function($event) {
        _vm.switchResourceType(2)
      }
    }
  }, [_vm._v("服务端使用资源")]), _vm._v(" "), _c('span', {
    staticClass: "l type-item",
    class: {
      active: _vm.resourceType == '3'
    },
    on: {
      "click": function($event) {
        _vm.switchResourceType('3')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-button', {
    staticClass: "r",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addResource
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.resourceList,
      "height": _vm.tableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              _vm.editResource(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.resourcename))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resourcetype",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resourcekey",
      "label": "资源KEY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteResource(scope.row.resourceid)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.diaTitle.resourceGroup
    },
    model: {
      value: (_vm.dia.resourceGroup),
      callback: function($$v) {
        _vm.$set(_vm.dia, "resourceGroup", $$v)
      },
      expression: "dia.resourceGroup"
    }
  }, [(_vm.dia.resourceGroup) ? _c('resource-group', {
    attrs: {
      "config": _vm.configGroup
    },
    on: {
      "cancel": _vm.cancelResourceGroup,
      "refresh": _vm.refreshResourceGroup
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.diaTitle.resource
    },
    model: {
      value: (_vm.dia.resource),
      callback: function($$v) {
        _vm.$set(_vm.dia, "resource", $$v)
      },
      expression: "dia.resource"
    }
  }, [(_vm.dia.resource) ? _c('resource', {
    attrs: {
      "config": _vm.configResource
    },
    on: {
      "cancel": _vm.cancelResource,
      "refresh": _vm.refreshResource
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-defb7854", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-defb7854","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resourceConfig/Index.vue
// module id = 246
// module chunks = 0